import * as React from 'react';
import { environmentVars } from 'constants/services';
import './loading-animation.css';
import { useTranslator } from '@bluebeam/react-i18n';
import classcat from 'classcat';

type LoadingAnimationProps = {
  /** @deprecated */
  align?: 'start' | 'center';

  /** Additional styling to apply */
  className?: string;

  /** The key of the translation to use. This key must be available in the `local` namespace. */
  loadingMessageKey?: string;

  /** @deprecated */
  pageName?: string;

  /** @deprecated */
  removePadding?: boolean;

  /** @deprecated */
  showAnimation?: boolean;
};

const LoadingAnimation: React.VFC<LoadingAnimationProps> = ({
  align,
  className,
  loadingMessageKey,
  pageName,
  removePadding,
  showAnimation,
}) => {
  const { translate } = useTranslator(['local']);

  // Branding loading animation - truck loader
  if (Boolean(environmentVars.BB_BRANDING) === false) {
    return (
      <div
        className={`flex flex-col grow ${
          removePadding ? '' : 'h100'
        } justify-center ${align === 'start' ? 'items-start' : 'items-center'}`}
      >
        {showAnimation ? (
          <div className="wrem-4p75 hrem-4p75 mb3 pos-r loading-animation">
            <div className="pos-a loading-animation-truck" />
            <div className="pos-a loading-animation-wheel loading-animation-wheel--front" />
            <div className="pos-a loading-animation-wheel loading-animation-wheel--back" />
          </div>
        ) : null}
        {pageName !== '' && (
          <div className="row justify-between">
            <div className="loading-animation-title">{pageName}</div>

            <div className="loading-animation-ellipsis-wrap">
              <div className="loading-animation-ellipsis">...</div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Default loading animation - growing dots
  return (
    <div className={classcat(['loading-overlay', className])}>
      <div
        aria-label={translate(
          `local:${loadingMessageKey}` as `local:${string}`
        )}
        className="loading-container"
        role="progressbar"
      >
        <div className="loading-dot loading-dot-first" />
        <div className="loading-dot" />
        <div className="loading-dot loading-dot-last" />
      </div>
    </div>
  );
};

LoadingAnimation.defaultProps = {
  loadingMessageKey: 'loading',
  pageName: '',
  showAnimation: true,
};

export default LoadingAnimation;
